import { API_BASE, ODATA_BASE } from "helpers/api_config";
import axios from "axios";
import { del, get, post, put, patch } from "./api_helper";
import * as url from "./url_helper";

// Gets the logged in user data from local session
const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

//is user is logged in
const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// Register Method
const postFakeRegister = data => {
  return axios
    .post(url.POST_FAKE_REGISTER, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      let message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

// Login Method

// postForgetPwd
const postFakeForgetPwd = data => post(url.POST_FAKE_PASSWORD_FORGET, data);

// Edit profile
const postJwtProfile = data => post(url.POST_EDIT_JWT_PROFILE, data);

const postFakeProfile = data => post(url.POST_EDIT_PROFILE, data);

// Register Method
const postJwtRegister = (url, data) => {
  return axios
    .post(url, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

// Login Method
const postJwtLogin = data => post(url.POST_FAKE_JWT_LOGIN, data);

// postForgetPwd
const postJwtForgetPwd = data => post(url.POST_FAKE_JWT_PASSWORD_FORGET, data);

// postSocialLogin
export const postSocialLogin = data => post(url.SOCIAL_LOGIN, data);

// get Products
export const getProducts = () => get(url.GET_PRODUCTS);

// get Product detail
export const getProductDetail = id =>
  get(`${url.GET_PRODUCTS_DETAIL}/${id}`, { params: { id } });

// get Events

// add Events

// update Event


// delete Event
export const deleteEvent = project =>
  del(`${API_BASE}/deleteEventMega/${project}`);


// get Categories

// get chats

// get groups
export const getGroups = () => get(url.GET_GROUPS);

// get Contacts
export const getContacts = () => get(url.GET_CONTACTS);

// get messages


// post messages
export const getselectedmails = (selectedmails) => post(url.GET_SELECTED_MAILS, selectedmails);

//post setfolderonmails
export const setfolderonmails = (selectedmails, folderId, activeTab) => post(url.SET_FOLDER_SELECTED_MAILS, { selectedmails, folderId, activeTab });

// get orders
export const getOrders = () => get(url.GET_ORDERS);

// add order
export const addNewOrder = order => post(url.ADD_NEW_ORDER, order);

// update order
export const updateOrder = order => put(url.UPDATE_ORDER, order);

// delete order
export const deleteOrder = order =>
  del(url.DELETE_ORDER, { headers: { order } });

// get cart data
export const getCartData = () => get(url.GET_CART_DATA);

// get customers
export const getCustomers = () => get(url.GET_CUSTOMERS);

// add CUSTOMER
export const addNewCustomer = customer => post(url.ADD_NEW_CUSTOMER, customer);

// update CUSTOMER
export const updateCustomer = customer => put(url.UPDATE_CUSTOMER, customer);

// delete CUSTOMER
export const deleteCustomer = customer =>
  del(url.DELETE_CUSTOMER, { headers: { customer } });

// get shops
export const getShops = () => get(url.GET_SHOPS);

// get wallet
export const getWallet = () => get(url.GET_WALLET);

// get crypto order
export const getCryptoOrder = () => get(url.GET_CRYPTO_ORDERS);

// get crypto product
export const getCryptoProduct = () => get(url.GET_CRYPTO_PRODUCTS);

// get invoices
export const getInvoices = () => get(url.GET_INVOICES);

// get invoice details
export const getInvoiceDetail = id =>
  get(`${url.GET_INVOICE_DETAIL}/${id}`, { params: { id } });

// get jobs
export const getJobList = () => get(url.GET_JOB_LIST);

// get Apply Jobs
export const getApplyJob = () => get(url.GET_APPLY_JOB);

// get project
export const getProjects = () => get(url.GET_PROJECTS);

// get project details
export const getProjectsDetails = id =>
  get(`${url.GET_PROJECT_DETAIL}/${id}`, { params: { id } });

// get tasks
export const getTasks = () => get(url.GET_TASKS);



export const getArticleDay = () => get(`${ODATA_BASE}/ArticleDay?$orderby=ID desc`).then(r => (r && r.value) ? r.value : r);
export const addArticleDay = job => post(`${ODATA_BASE}/ArticleDay`, job);
export const updateArticleDay = user => patch(`${ODATA_BASE}/ArticleDay(${user.ID})`, user);
export const deleteArticleDay = user => del(`${ODATA_BASE}/ArticleDay(${user})`);


export const updateNewsComment = user => patch(`${ODATA_BASE}/News_Comment(${user.ID})`, user);

export const getNews_Category = () => get(`${ODATA_BASE}/News_Category?$orderby=ID desc`).then(r => (r && r.value) ? r.value : r);
export const addNews_Category = job => post(`${ODATA_BASE}/News_Category`, job);
export const updateNews_Category = user => patch(`${ODATA_BASE}/News_Category(${user.ID})`, user);
export const deleteNews_Category = user => del(`${ODATA_BASE}/News_Category(${user})`);

export const getSongCategory = () => get(`${ODATA_BASE}/Song_Category?$orderby=ID desc`).then(r => (r && r.value) ? r.value : r);
export const addSongCategory = job => post(`${ODATA_BASE}/Song_Category`, job);
export const updateSongCategory = user => patch(`${ODATA_BASE}/Song_Category(${user.ID})`, user);
export const deleteSongCategory = user => del(`${ODATA_BASE}/Song_Category(${user})`);



export const getNews = () => get(`${ODATA_BASE}/News?$expand=News_Category&$orderby=ID desc`).then(r => (r && r.value) ? r.value : r);
export const addNews = job => post(`${ODATA_BASE}/News`, job);
export const updateNews = user => patch(`${ODATA_BASE}/News(${user.ID})`, user);
export const deleteNews = user => del(`${ODATA_BASE}/News(${user})`);

export const getNe = () => get(`${ODATA_BASE}/News?$expand=News_Category&$orderby=ID desc`).then(r => (r && r.value) ? r.value : r);
export const addNe = job => post(`${ODATA_BASE}/News`, job);
export const updateNe = user => patch(`${ODATA_BASE}/News(${user.ID})`, user);
export const deleteNe = user => del(`${ODATA_BASE}/News(${user})`);



export const getNews_Comment = () => get(`${ODATA_BASE}/News_Comment?$expand=Users,News($select=ID,News_Title)&$orderby=ID desc`).then(r => (r && r.value) ? r.value : r);
export const deleteNews_Comment = user => del(`${ODATA_BASE}/News_Comment(${user})`);
export const addForum = job => post(`${ODATA_BASE}/Forum`, job);




export const getPool = () => get(`${ODATA_BASE}/Pool?$expand=MainPage_Category&$orderby=ID desc`).then(r => (r && r.value) ? r.value : r);
export const addPool = job => post(`${ODATA_BASE}/Pool`, job);
export const updatePool = user => patch(`${ODATA_BASE}/Pool(${user.ID})`, user);
export const deletePool = user => del(`${ODATA_BASE}/Pool(${user})`);



export const getUsers = () => get(`${ODATA_BASE}/Users?$expand=Users_Type&$orderby=ID desc`).then(r => (r && r.value) ? r.value : r);
export const addUser = job => post(`${ODATA_BASE}/Users`, job);
export const updateUser = user => patch(`${ODATA_BASE}/Users(${user.ID})`, user);
export const deleteUser = user => del(`${ODATA_BASE}/Users(${user})`);


export const getSong = () => get(`${ODATA_BASE}/Song?$expand=Song_Category&$orderby=ID desc`).then(r => (r && r.value) ? r.value : r);
export const addSong = job => post(`${ODATA_BASE}/Song`, job);
export const updateSong = user => patch(`${ODATA_BASE}/Song(${user.ID})`, user);
export const deleteSong = user => del(`${ODATA_BASE}/Song(${user})`);

export const getSliders = () => get(`${ODATA_BASE}/Sliders?$expand=News($expand=News_Category),Forum,Job_Advertisement,MainPage_Category&$orderby=Sort asc,ID desc`).then(r => (r && r.value) ? r.value : r);
export const updateSlider = user => patch(`${ODATA_BASE}/Sliders(${user.ID})`, user);
export const deleteSlider = project => del(`${ODATA_BASE}/Sliders(${project})`);
  export const addSlider = job => post(`${ODATA_BASE}/Sliders`, job);


  export const getAdvert = () => get(`${ODATA_BASE}/Advert?$expand=Advert_Category&$orderby=ID desc`).then(r => (r && r.value) ? r.value : r);
  export const updateAdvert = user => patch(`${ODATA_BASE}/Advert(${user.ID})`, user);
  // Yanlis entity set'e (Advertesing) gidiyordu: reklam silinirken alakasiz kayit hedefleniyordu
  export const deleteAdvert = project => del(`${ODATA_BASE}/Advert(${project})`);
    export const addAdvert = job => post(`${ODATA_BASE}/Advert`, job);
  

  export const getAdvertesing_Category = () => get(`${ODATA_BASE}/Advertesing_Category?$orderby=ID desc`).then(r => (r && r.value) ? r.value : r);
  export const updateAdvertesing_Category = user => patch(`${ODATA_BASE}/Advertesing_Category(${user.ID})`, user);
  export const deleteAdvertesing_Category = project => del(`${ODATA_BASE}/Advertesing_Category(${project})`);
    export const addAdvertesing_Category = job => post(`${ODATA_BASE}/Advertesing_Category`, job);
  
  


  // En yeni basvurular ilk sayfada gorunsun (siralama yokken son sayfaya dusuyordu)
  // Yonlendirme kolonunda hedefin ADINI gosterebilmek icin ilgili kayitlar da cekiliyor
  export const getAdvertesing_Form = () => get(`${ODATA_BASE}/Advertesing_Form?$expand=Advertesing_Category,News($select=ID,News_Title),Forum($select=ID,Forum_Title),Job_Advertisement($select=ID,Job_Advertisement_Title)&$orderby=ID desc`).then(r => (r && r.value) ? r.value : r);
  export const updateAdvertesing_Form = user => patch(`${ODATA_BASE}/Advertesing_Form(${user.ID})`, user);
  export const deleteAdvertesing_Form = project => del(`${ODATA_BASE}/Advertesing_Form(${project})`);
    export const addAdvertesing_Form = job => post(`${ODATA_BASE}/Advertesing_Form`, job);
  
  

    export const getJob_Advertisement_Category = () => get(`${ODATA_BASE}/Job_Advertisement_Category?$orderby=ID desc`).then(r => (r && r.value) ? r.value : r);
    export const updateJob_Advertisement_Category = user => patch(`${ODATA_BASE}/Job_Advertisement_Category(${user.ID})`, user);
    export const deleteJob_Advertisement_Category = project => del(`${ODATA_BASE}/Job_Advertisement_Category(${project})`);
      export const addJob_Advertisement_Category = job => post(`${ODATA_BASE}/Job_Advertisement_Category`, job);
    
    



      export const getJob_Advertisement_SubCategory = () => get(`${ODATA_BASE}/Job_Advertisement_SubCategory?$expand=Job_Advertisement_Category&$orderby=ID desc`).then(r => (r && r.value) ? r.value : r);
      export const updateJob_Advertisement_SubCategory = user => patch(`${ODATA_BASE}/Job_Advertisement_SubCategory(${user.ID})`, user);
      export const deleteJob_Advertisement_SubCategory = project => del(`${ODATA_BASE}/Job_Advertisement_SubCategory(${project})`);
        export const addJob_Advertisement_SubCategory = job => post(`${ODATA_BASE}/Job_Advertisement_SubCategory`, job);
      
      

  
      export const getJob_Advertisement = () => get(`${ODATA_BASE}/Job_Advertisement?$expand=Users,Job_Advertisement_Image,Job_Advertisement_SubCategory($expand=Job_Advertisement_Category)&$orderby=ID desc`).then(r => (r && r.value) ? r.value : r);
      export const deleteJob_Advertisement = project => del(`${ODATA_BASE}/Job_Advertisement(${project})`);
     
  
      
      export const updateJob_Advertisement = user => patch(`${ODATA_BASE}/Job_Advertisement(${user.ID})`, user);

        export const getForum = () => get(`${ODATA_BASE}/Forum?$expand=Users&$orderby=ID desc`).then(r => (r && r.value) ? r.value : r);
        export const updateForum = user => patch(`${ODATA_BASE}/Forum(${user.ID})`, user);
        export const deleteForum = project => del(`${ODATA_BASE}/Forum(${project})`);
    
  export const getSubEducation = () => get(`${ODATA_BASE}/Sliders?$expand=News($expand=News_Category)`).then(r => (r && r.value) ? r.value : r);
  export const updateSubEducation = user => patch(`${ODATA_BASE}/Sliders(${user.ID})`, user);
  export const deleteSubEducation = project => del(`${ODATA_BASE}/Sliders(${project})`);
    export const addSubEducation = job => post(`${ODATA_BASE}/Sliders`, job);
  

  export const getCompany_Category = () => get(`${ODATA_BASE}/Company_Category?$orderby=ID desc`).then(r => (r && r.value) ? r.value : r);
export const updateCompany_Category = user => patch(`${ODATA_BASE}/Company_Category(${user.ID})`, user);
export const deleteCompany_Category = project => del(`${ODATA_BASE}/Company_Category(${project})`);
  export const addCompany_Category = job => post(`${ODATA_BASE}/Company_Category`, job);


  export const getCompany_SubCategory = () => get(`${ODATA_BASE}/Company_SubCategory?$expand=Company_Category&$orderby=ID desc`).then(r => (r && r.value) ? r.value : r);
export const updateCompany_SubCategory = user => patch(`${ODATA_BASE}/Company_SubCategory(${user.ID})`, user);
export const deleteCompany_SubCategory = project => del(`${ODATA_BASE}/Company_SubCategory(${project})`);
  export const addCompany_SubCategory = job => post(`${ODATA_BASE}/Company_SubCategory`, job);



  export const getMainPage_Category = () => get(`${ODATA_BASE}/MainPage_Category?$orderby=ID`).then(r => (r && r.value) ? r.value : r);
export const updateMainPage_Category = user => patch(`${ODATA_BASE}/MainPage_Category(${user.ID})`, user);
export const deleteMainPage_Category = project => del(`${ODATA_BASE}/MainPage_Category(${project})`);
  export const addMainPage_Category = job => post(`${ODATA_BASE}/MainPage_Category`, job);





  export const getCompany_Advert_Price = () => get(`${ODATA_BASE}/Company_Advert_Price?$orderby=ID desc`).then(r => (r && r.value) ? r.value : r);
  export const updateCompany_Advert_Price = user => patch(`${ODATA_BASE}/Company_Advert_Price(${user.ID})`, user);
  export const deleteCompany_Advert_Price = project => del(`${ODATA_BASE}/Company_Advert_Price(${project})`);
    export const addCompany_Advert_Price = job => post(`${ODATA_BASE}/Company_Advert_Price`, job);
  

export const getCompany = () => get(`${ODATA_BASE}/Company?$orderby=ID desc`).then(r => (r && r.value) ? r.value : r);
export const addCompany = job => post(`${ODATA_BASE}/Company`, job);
export const updateCompany = user => patch(`${ODATA_BASE}/Company(${user.ID})`, user);
export const deleteCompany = user => del(`${ODATA_BASE}/Company(${user})`);


export const addEducation = user => post(`${API_BASE}/addEducationNefes/send`, user);
export const addProductCategory = user => post(`${API_BASE}/addProductsCategoryLuxun/send`, user);
export const deleteProductCategory = user => del(`${API_BASE}/deleteProductCategoryLuxun/${user}`);
export const updateProductCategory = user => patch(`${API_BASE}/updateProductCategoryLuxun/${user.ID}`, user);

export const updateEducation = user => patch(`${API_BASE}/updateEducationNefes/${user.ID}`, user);

export const updateAbout = user => patch(`${API_BASE}/updateAboutCastor/${user.ID}`, user);
export const updateContact = user => patch(`${API_BASE}/updateContactCastor/${user.ID}`, user);
export const getCategory = () => get(`${API_BASE}/getProductsCategoryLuxun/select/`);
export const getProducts1 = () => get(`${API_BASE}/getProductsLuxun/select/`);

export const getSSS = () => get(`${API_BASE}/getSSSPort/select/`);
export const getBlogs = () => get(`${API_BASE}/getBlogCastor/select/`);

export const addNewUser = job => post(`${ODATA_BASE}/Forum`, job);

export const getProjectsNew = () => get(`${API_BASE}/getEducationNefes/select/`);
export const getEducation = () => get(`${API_BASE}/getEducationNefes/select/`);
export const getEducationSubItem = () => get(`${API_BASE}/getEducationSubItemNefes/select/`);
export const getPopup = () => get(`${ODATA_BASE}/Notification?$expand=Users&$orderby=ID desc`).then(r => (r && r.value) ? r.value : r);
export const getWorkShop = () => get(`${API_BASE}/getSUBDOMAINMega/select/`);

export const getCourseSchedulesMega = () => get(`${API_BASE}/getCourseSchedulesMega/select/`);

export const getWorkshopSessionMega = () => get(`${API_BASE}/getWorkshopSessionMega/select/`);

export const getTeacherMega = () => get(`${API_BASE}/getTeacherMega/select/`);

export const getEventMega = () => get(`${API_BASE}/getEventMega/select/`);

export const getDynamicFormMega = () => get(`${ODATA_BASE}/Pool?$expand=MainPage_Category,Pool_Answer&$orderby=ID desc`).then(r => (r && r.value) ? r.value : r);
export const updateDynamicForm = user => patch(`${ODATA_BASE}/Pool(${user.ID})`, user);
export const addDynamicForm = job => post(`${ODATA_BASE}/Pool`, job);
// ANKET SILME
//
// Once secenekleri (Pool_Answer), sonra anketin kendisini siler.
//
// NEDEN: Pool_Answer.Pool_ID -> Pool.ID yabanci anahtar kisiti var ve API
// art arda silme (cascade) YAPMIYOR. Secenegi olan bir anket dogrudan
// silinmek istenince sunucu 500 donuyordu; panelde silme sessizce
// basarisiz oluyor, kayit listede kaliyordu. (Secenegi olmayan anketler
// silinebildigi icin hata ancak bazi kayitlarda goruluyordu.)
export const deleteDynamicForm = async project => {
  const cevaplar = await get(`${ODATA_BASE}/Pool_Answer?$filter=Pool_ID eq ${project}&$select=ID`);
  const liste = (cevaplar && cevaplar.value) ? cevaplar.value : [];
  for (const cevap of liste) {
    await del(`${ODATA_BASE}/Pool_Answer(${cevap.ID})`);
  }
  return del(`${ODATA_BASE}/Pool(${project})`);
};


export const getMegaMega = () => get(`${API_BASE}/getMegaMega/select/`);

export const getMailsLists = () => get(`${API_BASE}/getContactMessageMega/select/`);

// add user

const postFakeLogin = data => get(`${ODATA_BASE}/Users?$filter=Users_MailAddress eq '${data.email}' and Users_Password eq '${data.password}'`).then(r => (r && r.value) ? r.value : r);

export const getEvents = () => get(`${API_BASE}/getEventMega/select/`);
export const getAbout = () => get(`${API_BASE}/getAboutCastor/select/`);
export const getCategories = () => get(`${API_BASE}/getEventCategoryMega/select/`);




export const updatePopup = user => patch(`${API_BASE}/patchPopupMega/${user.ID}`, user);

export const updateSubDomain = user => patch(`${API_BASE}/patchSUBDOMAINMega/${user.ID}`, user);

export const updateCourseSchedules = user => patch(`${API_BASE}/patchCourseSchedulesMega/${user.ID}`, user);

export const updateWorkshopSession = user => patch(`${API_BASE}/patchWorkShopSessionMega/${user.ID}`, user);

export const updateTeacher = user => patch(`${API_BASE}/patchUserMega/${user.ID}`, user);


export const updateSSS = user => patch(`${API_BASE}/updateSSSPort/${user.ID}`, user);

export const updateProduct = user => patch(`${API_BASE}/updateProductLuxun/${user.ID}`, user);
export const updateBlog = user => patch(`${API_BASE}/updateBlogCastor/${user.ID}`, user);



export const updateProject = user => patch(`${API_BASE}/patchUpdateProject/${user.ID}`, user);


export const addPopup = job => post(`${API_BASE}/addPopup/send`, job);


export const addSSS= job => post(`${API_BASE}/addSSSPort/send`, job);
export const addProduct = job => post(`${API_BASE}/addProductLuxun/send`, job);

export const addBlog = job => post(`${API_BASE}/addBlogCastor/send`, job);
export const addProject = job => post(`${API_BASE}/addProject/send`, job);



export const addMega = job => post(`${API_BASE}/addMega/send`, job);

export const addCourseMega = job => post(`${API_BASE}/addCourseMega/send`, job);

export const updateSubdomain = user => patch(`${API_BASE}/patchSUBDOMAINMega/${user.ID}`, user);



export const updateAuth = user => patch(`${API_BASE}/patchAuthMega/${user.ID}`, user);

export const updateMega = user => patch(`${API_BASE}/patchMegaMega/${user.ID}`, user);

export const updateGallery = user => patch(`${API_BASE}/patchGalleryMega/${user.ID}`, user);

export const updateEvent = event => patch(`${API_BASE}/patchEventMega/${event.ID}`, event);

export const addAppSetting = job => post(`${API_BASE}/postWSMega/send`, job);

export const addWorkshop2 = job => post(`${API_BASE}/postWorkshopMega/send`, job);



// delete user

export const getContact = () => get(`${API_BASE}/getContactCastor/select/`);
export const getAuthority = () => get(`${API_BASE}/getUsersTypeMega/select/`);
export const getWorkshop2 = () => get(`${API_BASE}/getWorkshopMega/select/`);

export const updateWorkShop2 = user => patch(`${API_BASE}/patchWorkshop2Mega/${user.ID}`, user);

export const getGallery = () => get(`${API_BASE}/getGalleryMega/select/`);

export const addNewEvent = event => post(`${API_BASE}/postEventMega/send/`, event);

export const getChats = () => get(`${API_BASE}/getContactMessageMega/select/`);

export const getMessages = (roomId = "") => get(`${API_BASE}/getContactMessageDetailMega/select/${roomId}`);

export const addNewSubdomain = event => post(`${API_BASE}/postSubdomainMega/send/`, event);
export const getReferances = () => get(`${API_BASE}/getReferancesMega/select/`);
// add jobs
export const addNewJobList = job => post(url.ADD_NEW_JOB_LIST, job);
// update jobs
export const updateJobList = job => put(url.UPDATE_JOB_LIST, job);
// delete jobs
export const deleteJobList = job => del(url.DELETE_JOB_LIST, { headers: { job } });
// Delete Apply Jobs
export const deleteApplyJob = data => del(url.DELETE_APPLY_JOB, { headers: { data } });
/** PROJECT */
// add user
export const addNewProject = project => post(url.ADD_NEW_PROJECT, project);

export const addReferances = event => post(`${API_BASE}/postReferancesMega/send/`, event);

export const updateReferances = user => patch(`${API_BASE}/patchReferancesMega/${user.ID}`, user);

export const getSubProject = (ID = "") => get(`${API_BASE}/getProjectSubItem/select/${ID}`);

export const getTeacherWorkshop = () => get(`${API_BASE}/getTeacherWorkshopMega/select/`);

export const addLessonsTime = event => post(`${API_BASE}/postLessonsTimeMega/send/`, event);

export const updateLessonsTime = user => patch(`${API_BASE}/patchTeacherWorkshopMega/${user.ID}`, user);

export const getClassAttendance = () => get(`${API_BASE}/getClassAttendanceMega/select/`);

export const getClassesMega = () => get(`${API_BASE}/getClassesMega/select/`);

export const getDynamicFormExtraMega = (ID = "") => get(`${API_BASE}/getDynamicFormExtraMega/select/${ID}`);

export const getDynamicFormExtraExtraMega = (ID = "") => get(`${API_BASE}/getDynamicFormExtraExtraMega/select/${ID}`);


export const addGallerry = job => post(`${API_BASE}/postGalleryMega/send`, job);

export const addMultipleGalleryForm = job => post(`${API_BASE}/postGalleryMultipleMega/send`, job);


export const deleteDynamicFormExtraExtra = project =>
  del(`${API_BASE}/deleteDynamicExtraExtraFormMega/${project}`);


export const deleteDynamicFormExtra = project =>
  del(`${API_BASE}/deleteDynamicFormExtraMega/${project}`);

export const deleteCourseSchedules = project =>
  del(`${API_BASE}/deleteCourseSchedulesMega/${project}`);

export const deleteGallery = project =>
  del(`${API_BASE}/deleteGalleryMega/${project}`);

export const deleteReferances = project =>
  del(`${API_BASE}/deleteReferancesMega/${project}`);

export const deletePopup = project =>
  del(`${API_BASE}/deletePopupMega/${project}`);



  export const deleteSSS = project =>
  del(`${API_BASE}/deleteSSSPort/${project}`);
  





export const deleteProduct = project =>
del(`${API_BASE}/deleteProductLuxun/${project}`);

  export const deleteBlog = project =>
  del(`${API_BASE}/deleteblogCastor/${project}`);


  
export const deleteMega = project =>
  del(`${API_BASE}/deleteMega/${project}`);

export const deleteProject = project =>
  del(url.DELETE_PROJECT, { headers: { project } });

export const getUserProfile = () => get(url.GET_USER_PROFILE);

// get maillist
//update mail
export const updateMail = mail => put(url.UPDATE_MAIL, mail);

// get folderlist
export const selectFolders = () => get(url.SELECT_FOLDER);

// post messages
export const addMessage = message => post(url.ADD_MESSAGE, message);

// get dashboard charts data
export const getWeeklyData = () => get(url.GET_WEEKLY_DATA);
export const getYearlyData = () => get(url.GET_YEARLY_DATA);
export const getMonthlyData = () => get(url.GET_MONTHLY_DATA);

export const walletBalanceData = month =>
  get(`${url.GET_WALLET_DATA}/${month}`, { params: { month } });

export const getStatisticData = duration =>
  get(`${url.GET_STATISTICS_DATA}/${duration}`, { params: { duration } });

export const visitorData = duration =>
  get(`${url.GET_VISITOR_DATA}/${duration}`, { params: { duration } });

export const topSellingData = month =>
  get(`${url.TOP_SELLING_DATA}/${month}`, { params: { month } });

export const getEarningChartsData = month =>
  get(`${url.GET_EARNING_DATA}/${month}`, { params: { month } });

const getProductComents = () => get(url.GET_PRODUCT_COMMENTS);

const onLikeComment = (commentId, productId) => {
  return post(`${url.ON_LIKNE_COMMENT}/${productId}/${commentId}`, {
    params: { commentId, productId },
  });
};
const onLikeReply = (commentId, productId, replyId) => {
  return post(`${url.ON_LIKNE_COMMENT}/${productId}/${commentId}/${replyId}`, {
    params: { commentId, productId, replyId },
  });
};

const onAddReply = (commentId, productId, replyText) => {
  return post(`${url.ON_ADD_REPLY}/${productId}/${commentId}`, {
    params: { commentId, productId, replyText },
  });
};

const onAddComment = (productId, commentText) => {
  return post(`${url.ON_ADD_COMMENT}/${productId}`, {
    params: { productId, commentText },
  });
};

export {
  getLoggedInUser,
  isUserAuthenticated,
  postFakeRegister,
  postFakeLogin,
  postFakeProfile,
  postFakeForgetPwd,
  postJwtRegister,
  postJwtLogin,
  postJwtForgetPwd,
  postJwtProfile,
  getProductComents,
  onLikeComment,
  onLikeReply,
  onAddReply,
  onAddComment,
};